import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { noop } from 'ui-components/default-props/noop';
import { testId } from 'ui-components/services/testid-service';

import SimpleProgressIndicator from './components/batch-state-mid-section/simple-progress-indicator';
import CompletedTileHeader from './components/completed-tile-header';
import { TileFooterActions } from './components/tile-footer-actions';
import TileFooterErrorOrWarningContainer from '../../containers/footer-error-or-warning.container';
import OrderOrBatchNumberContainer from '../../components/label-que-batch-tile/components/order-or-batch-number';

import { emptyObject } from 'ui-components/default-props/empty';
import style from './style.module.less';

const LabelQueBatchTile = ({ batch = emptyObject, isSelected = false, onToggleBatchSelected = noop }) => {
  const { batchId, total, batchNumber, processDate, completed, warnings, errors, isComplete, isMarkedForExclusion } = batch;
  const classNames = classnames(style['label-que-batch'], { [style.selected]: isSelected }, { [style.faded]: isMarkedForExclusion });
  return (
    <div className={classNames}>
      {isComplete && (
        <CompletedTileHeader
          batchId={batchId}
          batchNumber={batchNumber}
          isSelected={isSelected}
          onToggleBatchSelected={onToggleBatchSelected}
          processDate={processDate}
          total={total}
        />
      )}
      {!isComplete && (
        <div className={style['incomplete-batch-tile-header']} {...testId('incomplete-batch-tile-header')}>
          <OrderOrBatchNumberContainer batchId={batchId} />
        </div>
      )}
      <div className={style['tile-mid-section']}>
        <SimpleProgressIndicator completed={completed} errorCount={errors} total={total} warningCount={warnings} />
      </div>
      {isComplete && <TileFooterActions batchId={batchId} />}
      {isComplete && (batch.errors > 0 || batch.warnings > 0) && (
        <TileFooterErrorOrWarningContainer batchId={batchId} errorCount={errors} warningCount={warnings} />
      )}
    </div>
  );
};

LabelQueBatchTile.propTypes = {
  batch: PropTypes.object,
  isSelected: PropTypes.bool,
  onToggleBatchSelected: PropTypes.func,
};

export default LabelQueBatchTile;
